export default __webpack_public_path__ + "static/media/bacqueville18.bc3dfbd9.jpg";